import React, { useEffect, useRef, useState } from "react";
import { Text, View } from "../../../shared/Themed";
import { Checkbox, DataTable } from "react-native-paper";
import * as Services from "../../../../utils/common";
import { Badge } from "@react-native-material/core";
import { StyleSheet, Platform } from "react-native";

import Icon from "react-native-vector-icons/FontAwesome5";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import Spinner from "../../../shared/Spinner";

import { default as statusColorCodes } from "../../../../utils/constants/statusColorCodes";
import { ReadOnlyProps } from "../../../../utils/templates";
import { formatValueAsDataType } from "../../../../utils/common";
import { NoDataBanner } from "../../../shared/NoDataBanner";
import { MaterialCommunityIcons, SimpleLineIcons } from "@expo/vector-icons";
import CustomProgressBar from "../../../../screens/ItemTracker/utils/CustomProgressBar";
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from "react-native-popup-menu";
import { useSelector } from "react-redux";
import { ChinaNestedDataTableWithPagination2 } from "./ChinaNestedDataTableWithPagination2";

interface Props {
  headers: any;
  rows: Array<any>;
  itemsPerPage: number;
  useModal: boolean;
  isDataLoading?: boolean;
  isDisplayTimeWithDate?: boolean;
  setModalVisible: (event: any) => void;
  setDeliveryModalVisible?: any;
  handleRowClick: (event: any) => void;
  setSelected: (event: any) => void;
  setSelectedDeliveryItem?: (event: any) => void;

  //Nested Table Variables
  rowKeyValue?: string;
  nestedItemKeyValue?: string;
  nestedHeader?: any;
  isRowsExpandable?: boolean;
  isNestedDataLoaded?: boolean;
  isToExpandAllRows?: boolean;

  isDetail?: boolean; //Control Modal variable
  isEdit?: boolean; //Edit Button variable
  isDelete?: boolean; //Delete Button variable
  isSubDetail?: boolean; //Control Sub Modal variable
  handleDeleteRow: (id: string | number) => void;

  //exclude column to not have thousand separator format
  columnsToNotHaveThousandSeparator?: Array<string>;

  //handle sorting
  handleSortColumn?: (columnKey: string) => void;
  handleNestedSortColumn?: (
    columnKey: string,
    columnParentIdentifier: string,
  ) => void;

  operationsScreen?: boolean;
  disableHeader?: boolean;
  operationActions?: (order: any, action: string) => void;
  isDeliveryAttachment?: boolean;
  itemTracker?: boolean;
  actionRow?: any;
  setActionRow?: any;
  navigatePressAction?: (filterField: string, filterValue: string) => void;
  t?: any;
  page?: number;
  setPage?: any;
  selectable?: boolean;
}

export const ChinaTrackerDataTableWithPagination: React.FC<
  ReadOnlyProps<Props>
> = ({
  headers,
  rows,
  itemsPerPage,
  useModal,
  nestedHeader,
  rowKeyValue,
  nestedItemKeyValue,
  isDisplayTimeWithDate = false,
  isDataLoading = false,
  isRowsExpandable = false,
  isNestedDataLoaded = false,
  isToExpandAllRows = false,
  setModalVisible,
  setDeliveryModalVisible,
  handleRowClick,
  setSelected,
  isDetail = false,
  isSubDetail = false,
  isEdit = false,
  isDelete = false,
  handleDeleteRow,
  columnsToNotHaveThousandSeparator,
  handleSortColumn,
  handleNestedSortColumn,
  operationsScreen,
  disableHeader,
  operationActions,
  isDeliveryAttachment = false,
  setSelectedDeliveryItem,
  itemTracker = false,
  actionRow = null,
  setActionRow,
  navigatePressAction,
  page,
  setPage,
  t,
  selectable,
}: ReadOnlyProps<Props>) => {
  const [currentRow, setCurrentRow] = useState<string>("");
  const [expandRow, setExpandRow] = useState<boolean>(false);
  const [expandAllRows, setExpandAllRows] = useState<boolean>(false);
  const [_itemsPerPage] = useState<number>(itemsPerPage);
  const language = useSelector((state: any) => state.configurations.language);

  const lastMsPressRef = useRef<number>(0);
  const DOUBLE_PRESS_DELAY = 300;

  const fromPage = (
    page: number,
    itemPerPage: number,
    rows: any[] | undefined,
  ) => {
    return page * itemPerPage + itemPerPage > (rows || []).length
      ? (rows || []).length
      : page * itemPerPage + itemPerPage;
  };

  useEffect(() => {
    setExpandAllRows(isToExpandAllRows);
  }, [isToExpandAllRows]);

  const handleNavigatePress = (field: string, value: any) => {
    // Prevent navigation if the user is highlighting text on the web
    const isTextSelected = () => {
      if (Platform.OS === "web" && typeof window !== "undefined") {
        return (window.getSelection()?.toString()?.length || 0) > 0;
      }
      return false;
    };

    if (isTextSelected()) return;

    const doublePressFields = ["MSRef", "OrderNumber1", "StateDelivery"];
    if (!doublePressFields.includes(field)) {
      navigatePressAction?.(field, value);
      return;
    }

    const now = Date.now();
    if (now - lastMsPressRef.current < DOUBLE_PRESS_DELAY) {
      navigatePressAction?.(field, value);
    }
    lastMsPressRef.current = now;
  };

  const handleRowClicking = (row: any, clickType: string) => {
    if (useModal && clickType === "details") {
      setModalVisible(true);
      setSelected(row);
    } else if (clickType === "edit") {
      handleRowClick(row);
    } else if (clickType === "delivery") {
      setDeliveryModalVisible(true);
      setSelectedDeliveryItem(row);
    }
  };

  const headersView = (headers: any) => {
    const views: Array<any> = [];
    if (headers && !itemTracker) {
      Object.keys(headers).forEach((value, index) => {
        views.push(
          <DataTable.Title
            style={{
              flex: headers[value].width,
            }}
            key={Services.makeid(10)}
          >
            <View style={{ width: 120 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  width: "100%",
                  textAlign: headers[value].textAlign,
                }}
              >
                {index === 0 && isRowsExpandable && !itemTracker && (
                  <>
                    <TouchableOpacity
                      onPress={() => handleExpandableAllRowIcon()}
                    >
                      <Icon
                        name={!expandAllRows ? "plus-square" : "minus-square"}
                        size={15}
                        color={
                          headers[value].color ? headers[value].color : "black"
                        }
                      />
                    </TouchableOpacity>
                    &nbsp;&nbsp;
                  </>
                )}
                <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                  <Text
                    style={{
                      color: headers[value].color
                        ? headers[value].color
                        : "black",
                      fontWeight: headers[value].fontWeight
                        ? headers[value].fontWeight
                        : 700,
                    }}
                  >
                    {headers[value].name}
                  </Text>
                </TouchableOpacity>{" "}
                &nbsp;&nbsp;
                {headers[value].isSort && rows.length > 1 && (
                  <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                    <Icon
                      name={
                        headers[value].sortDirection === "asc"
                          ? "sort-alpha-down"
                          : "sort-alpha-up"
                      }
                      size={13}
                      color="black"
                    />
                  </TouchableOpacity>
                )}
              </Text>
            </View>
          </DataTable.Title>,
        );
      });
      return views;
    }

    if (headers && itemTracker) {
      Object.keys(headers).forEach((value, index) => {
        headers[value].display != "hidden" &&
          views.push(
            <DataTable.Title
              style={{
                flex: headers[value].width,
              }}
              key={Services.makeid(10)}
            >
              <View style={{ width: 120 }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: headers[value].textAlign,
                  }}
                >
                  {index === 0 && isRowsExpandable && (
                    <>
                      <TouchableOpacity
                        onPress={() => handleExpandableAllRowIcon()}
                      >
                        <Icon
                          name={!expandAllRows ? "plus-square" : "minus-square"}
                          size={15}
                          color={
                            headers[value].color
                              ? headers[value].color
                              : "black"
                          }
                        />
                      </TouchableOpacity>
                      &nbsp;&nbsp;
                    </>
                  )}
                  <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                    <Text
                      style={{
                        color: headers[value].color
                          ? headers[value].color
                          : "black",
                        fontWeight: 700,
                        paddingLeft: index === 0 && isRowsExpandable ? 30 : 0,
                        fontSize: headers[value].fontSize
                          ? headers[value].fontSize
                          : language === "en"
                            ? 10
                            : 12,
                        display: headers[value].display
                          ? headers[value].display
                          : "block",
                      }}
                    >
                      {headers[value].name}
                    </Text>
                  </TouchableOpacity>{" "}
                  &nbsp;&nbsp;
                  {headers[value].isSort && rows.length > 1 && (
                    <TouchableOpacity onPress={() => handleSortColumn?.(value)}>
                      <Icon
                        name={
                          headers[value].sortDirection === "asc"
                            ? "sort-alpha-down"
                            : "sort-alpha-up"
                        }
                        size={13}
                        color="black"
                      />
                    </TouchableOpacity>
                  )}
                </Text>
              </View>
            </DataTable.Title>,
          );
      });
      return views;
    }
  };

  const displayExpandableIcons = (
    row: any,
    expandRow: boolean,
    expandAllRows: boolean,
  ): string => {
    if (!expandRow && !expandAllRows) {
      return "plus-square";
    } else if (row[rowKeyValue as string] === currentRow || expandAllRows) {
      return "minus-square";
    } else {
      return "plus-square";
    }
  };

  // Function to get status color
  const getStatusColor = (status: string) => {
    switch (status) {
      case "On Time":
        return "#11C001"; // Green
      case "At Risk":
        return "#EBE00C"; // Yellow
      case "Interrupted":
        return "#FF0000"; // Red
      default:
        return "#000"; // Default Black
    }
  };

  const handleExpandableAllRowIcon = () => {
    setCurrentRow("");
    setExpandAllRows(!expandAllRows);
  };

  const handleExpandableRowIcon = (row: any, currentIcon: string) => {
    const isRowExpanded = currentIcon === "plus-square";
    // setCurrentRow(row[rowKeyValue as string]);
    setCurrentRow(row[rowKeyValue as string]);
    setExpandRow(isRowExpanded);
  };

  const cellsView = (rows: Array<any>, headers: any) => {
    const rowsViews: Array<React.ReactNode> = [];
    rows.forEach((row, index) => {
      let views: Array<React.ReactNode> = [];
      const switchToExpand =
        (expandRow || expandAllRows) &&
        (row[rowKeyValue as string] === currentRow || expandAllRows);

      setSelected(row);

      Object.keys(headers).map((value, index) => {
        if (row) {
          if (!["status", "ship_status"].includes(value) && !itemTracker) {
            views.push(
              <View
                style={{
                  flex: headers[value].width,
                  borderColor: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: operationsScreen
                    ? "#fff"
                    : switchToExpand
                      ? "#eee"
                      : "white",
                }}
                key={Services.makeid(10)}
              >
                {index === 0 && isRowsExpandable ? (
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignSelf: "flex-start",
                      backgroundColor: operationsScreen
                        ? "#fff"
                        : switchToExpand
                          ? "#eee"
                          : "white",
                    }}
                  >
                    {!expandAllRows && (
                      <TouchableOpacity
                        onPress={() =>
                          handleExpandableRowIcon(
                            row,
                            displayExpandableIcons(
                              row,
                              expandRow,
                              expandAllRows,
                            ),
                          )
                        }
                      >
                        <Icon
                          name={displayExpandableIcons(
                            row,
                            expandRow,
                            expandAllRows,
                          )}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    <Text
                      selectable={selectable}
                      style={operationsScreen && { fontWeight: "500" }}
                    >
                      &nbsp;{row[value]}
                    </Text>
                  </View>
                ) : value === "" ? (
                  <View
                    style={{
                      flexDirection: "row",
                      backgroundColor: operationsScreen
                        ? "#fff"
                        : switchToExpand
                          ? "#eee"
                          : "white",
                    }}
                  >
                    {isDetail && (
                      <TouchableOpacity
                        onPress={() => handleRowClicking(row, "details")}
                      >
                        <Icon
                          style={{ marginRight: "5px" }}
                          name={"info-circle"}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isDeliveryAttachment && (
                      <TouchableOpacity
                        onPress={() => handleRowClicking(row, "delivery")}
                      >
                        <Icon
                          style={{ marginRight: "5px" }}
                          name={"paperclip"}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isEdit && (
                      <TouchableOpacity
                        onPress={() => handleRowClicking(row, "edit")}
                      >
                        <Icon
                          style={{ marginRight: "5px" }}
                          name={"edit"}
                          size={15}
                          color={
                            operationsScreen ? "#000" : "rgb(47, 149, 220)"
                          }
                        />
                      </TouchableOpacity>
                    )}
                    {isDelete && (
                      <TouchableOpacity
                        onPress={() =>
                          handleDeleteRow(row[rowKeyValue as string] as string)
                        }
                      >
                        <Icon name={"trash"} size={15} color="rgb(178,34,34)" />
                      </TouchableOpacity>
                    )}
                  </View>
                ) : (
                  <Text
                    selectable={selectable}
                    style={{
                      fontSize: 12,
                      width: "100%",
                      textAlign: headers[value].textAlign,
                    }}
                  >
                    {columnsToNotHaveThousandSeparator?.includes(
                      headers[value].name,
                    )
                      ? `${
                          headers[value].name.includes("Uom1")
                            ? `${row[value]} (${row["InvntryUom"]})`
                            : headers[value].name.includes("Uom2")
                              ? `${row[value]} (${row["Uom2"]})`
                              : `${row[value]}`
                        }`
                      : formatValueAsDataType(
                          row[value],
                          isDisplayTimeWithDate,
                        ) || 0}
                  </Text>
                )}
              </View>,
            );
          }

          if (["status", "ship_status"].includes(value)) {
            views.push(
              <View
                style={{
                  flex: headers[value].width,
                  borderColor: "white",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  backgroundColor: operationsScreen
                    ? "#fff"
                    : switchToExpand
                      ? "#eee"
                      : "white",
                }}
                key={Services.makeid(10)}
              >
                <Badge
                  label={row[value]}
                  tintColor="white"
                  color={statusColorCodes[row[value]]}
                />
              </View>,
            );
          }

          if (itemTracker) {
            headers[value].display !== "hidden" &&
              views.push(
                <View
                  style={{
                    flex: headers[value].width,
                    borderColor: "white",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: operationsScreen
                      ? "#fff"
                      : switchToExpand
                        ? "#f8f8f8"
                        : "white",
                  }}
                  key={Services.makeid(10)}
                >
                  {index === 0 && isRowsExpandable ? (
                    <View
                      style={{
                        flexDirection: "row",
                        alignSelf: "flex-start",
                        backgroundColor: operationsScreen
                          ? "#fff"
                          : switchToExpand
                            ? "#f8f8f8"
                            : "white",
                      }}
                    >
                      {!expandAllRows && (
                        <TouchableOpacity
                          onPress={() =>
                            handleExpandableRowIcon(
                              row,
                              displayExpandableIcons(
                                row,
                                expandRow,
                                expandAllRows,
                              ),
                            )
                          }
                        >
                          <Icon
                            name={displayExpandableIcons(
                              row,
                              expandRow,
                              expandAllRows,
                            )}
                            size={15}
                            color={
                              operationsScreen ? "#000" : "rgb(47, 149, 220)"
                            }
                          />
                        </TouchableOpacity>
                      )}
                      <Text
                        selectable={selectable}
                        style={operationsScreen && { fontWeight: "500" }}
                        onPress={() => handleNavigatePress(value, row[value])}
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row[value]}
                      </Text>
                    </View>
                  ) : ["allocateProductionLine"].includes(value) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        width: "100%",
                      }}
                    >
                      {Array.isArray(row[value])
                        ? row[value].join(", ")
                        : (row[value] ?? "")}
                    </Text>
                  ) : ["FulfillmentPercent"].includes(value) ? (
                    <CustomProgressBar
                      progress={row[value]}
                      chinaTracker={true}
                    />
                  ) : ["Checkbox"].includes(value) ? (
                    <Checkbox
                      status={actionRow === row ? "checked" : "unchecked"}
                      onPress={() => {
                        actionRow === null
                          ? setActionRow(row)
                          : setActionRow(null);
                      }}
                    />
                  ) : ["DaysLeft"].includes(value) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        width: "100%",
                        textAlign: "left",
                      }}
                    >
                      {row[value]}
                    </Text>
                  ) : ["incomingStatus"].includes(value) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        width: "100%",
                        textAlign: "left",
                      }}
                    >
                      {row[value] === "REVISED_BY_PURCHASING"
                        ? "REVISED BY PURCHASING"
                        : row[value]}
                    </Text>
                  ) : ["OrderStatus"].includes(value) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        color: getStatusColor(row[value]), // Apply status color
                        fontWeight: "bold",
                        width: "100%",
                        textAlign: "left",
                      }}
                    >
                      {row[value] === "At Risk"
                        ? t("atRisk")
                        : row[value] === "On Time"
                          ? t("onTime")
                          : row[value] === "Delayed"
                            ? t("delayed")
                            : row[value] === "Planned"
                              ? t("planned")
                              : row[value] === "No Data"
                                ? t("noData")
                                : row[value] === "Interrupted"
                                  ? t("interrupted")
                                  : row[value] === "Cancelled"
                                    ? t("cancelled")
                                    : row[value] === "Completed"
                                      ? t("completed")
                                      : t("closed")}
                    </Text>
                  ) : ["ItemCode"].includes(value) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        width: "100%",
                        textAlign: "left",
                      }}
                      onPress={() =>
                        operationActions?.(row?.ItemCode, "itemCodeReport")
                      }
                    >
                      {row[value]}
                    </Text>
                  ) : ["PriorityOrder"].includes(value) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        width: "100%",
                        textAlign: "left",
                      }}
                      onPress={() => operationActions?.(row, "priority")}
                    >
                      {row[value] === "High"
                        ? t("high")
                        : row[value] === "Medium"
                          ? t("medium")
                          : t("normal")}
                    </Text>
                  ) : !["trackerActions_sm", "trackerActions"].includes(
                      value,
                    ) ? (
                    <Text
                      selectable={selectable}
                      style={{
                        fontSize: 12,
                        width: "100%",
                        paddingRight: (() => {
                          const isQtyColumn = ["Qty", "Total"].some((item) =>
                            value.includes(item),
                          );
                          const isOrderQtyColumn =
                            value === "TotalOrdered" ||
                            headers[value]?.name?.includes("Order Qty");
                          return isQtyColumn && !isOrderQtyColumn ? 30 : 0;
                        })(),
                        textAlign: (() => {
                          const isNameColumn = ["Name", "Sales"].some((item) =>
                            value.includes(item),
                          );
                          if (isNameColumn) {
                            return "left";
                          }
                          const isOrderQtyColumn =
                            value === "TotalOrdered" ||
                            headers[value]?.name?.includes("Order Qty");
                          if (isOrderQtyColumn) {
                            return "center";
                          }
                          return ["Qty", "Total"].some((item) =>
                            value.includes(item),
                          )
                            ? "right"
                            : "left";
                        })(),
                      }}
                      onPress={() => handleNavigatePress(value, row[value])}
                    >
                      {columnsToNotHaveThousandSeparator?.includes(
                        headers[value].name,
                      )
                        ? headers[value].name.includes("Uom1")
                          ? `${row[value]} (${row["InvntryUom"]})`
                          : headers[value].name.includes("Uom2")
                            ? `${row[value]} (${row["Uom2"]})`
                            : headers[value].name.includes("OrderQty")
                              ? `${row[value]} (${row[value]?.toLocaleString()})`
                              : row[value]
                        : headers[value]?.name?.includes("Qty")
                          ? row[value]?.toLocaleString()
                          : headers[value]?.name?.includes("数量")
                            ? row[value]?.toLocaleString()
                            : row[value]}
                    </Text>
                  ) : ["trackerActions_sm"].includes(value) ? (
                    <View style={{ flexDirection: "row" }}>
                      <View>
                        <Menu>
                          <MenuTrigger>
                            <View
                              style={{
                                justifyContent: "center",
                                alignContent: "center",
                                paddingLeft: 10,
                                width: 25,
                              }}
                            >
                              <Text>
                                <SimpleLineIcons
                                  name="options"
                                  size={18}
                                  color="grey"
                                />
                              </Text>
                            </View>
                          </MenuTrigger>
                          <MenuOptions
                            optionsContainerStyle={{
                              padding: 2,
                              zIndex: 999,
                              marginLeft: -25,
                              marginTop: -10,
                              width: 140,
                            }}
                          >
                            <View style={{ flexDirection: "row" }}>
                              <View style={styles.menuOptionContainer}>
                                <MenuOption
                                  style={{
                                    flex: 1,
                                    alignItems: "center",
                                  }}
                                  onSelect={() =>
                                    operationActions?.(row, "view")
                                  }
                                >
                                  <Text>
                                    <MaterialCommunityIcons
                                      name="eye"
                                      size={20}
                                      color="#5F6368"
                                      style={[styles.actionsIcons]}
                                    />
                                  </Text>
                                </MenuOption>
                              </View>
                              <View style={styles.menuOptionContainer}>
                                <MenuOption
                                  style={{
                                    flex: 1,
                                    alignItems: "center",
                                  }}
                                  disabled={
                                    row?.OrderStatus === "Cancelled"
                                      ? true
                                      : false
                                  }
                                  onSelect={() =>
                                    operationActions?.(row, "flag")
                                  }
                                >
                                  <Text>
                                    <MaterialCommunityIcons
                                      name="flag-outline"
                                      size={20}
                                      color={
                                        row?.OrderStatus === "Cancelled"
                                          ? "#eee"
                                          : "#5F6368"
                                      }
                                      style={[styles.actionsIcons]}
                                    />
                                  </Text>
                                </MenuOption>
                              </View>
                              <View style={styles.menuOptionContainer}>
                                <MenuOption
                                  style={{
                                    flex: 1,
                                    alignItems: "center",
                                  }}
                                  disabled={
                                    row?.OrderStatus === "Cancelled"
                                      ? true
                                      : false
                                  }
                                  onSelect={() =>
                                    operationActions?.(row, "add")
                                  }
                                >
                                  <Text>
                                    <MaterialCommunityIcons
                                      name="comment-outline"
                                      size={20}
                                      color={
                                        row?.OrderStatus === "Cancelled"
                                          ? "#eee"
                                          : "#5F6368"
                                      }
                                      style={[styles.actionsIcons]}
                                    />
                                  </Text>
                                </MenuOption>
                              </View>
                              <View style={styles.menuOptionContainer}>
                                <MenuOption
                                  style={{
                                    flex: 1,
                                    alignItems: "center",
                                  }}
                                  onSelect={() =>
                                    operationActions?.(row, "history")
                                  }
                                >
                                  <Text>
                                    <MaterialCommunityIcons
                                      name="clock-outline"
                                      size={20}
                                      color="#5F6368"
                                      style={[styles.actionsIcons]}
                                    />
                                  </Text>
                                </MenuOption>
                              </View>

                              <View style={styles.menuOptionContainer}>
                                <MenuOption
                                  style={{
                                    flex: 1,
                                    alignItems: "center",
                                  }}
                                  onSelect={() =>
                                    operationActions?.(row, "shipments")
                                  }
                                >
                                  <Text>
                                    <MaterialCommunityIcons
                                      name="truck-outline"
                                      size={20}
                                      color="#5F6368"
                                      style={[styles.actionsIcons]}
                                    />
                                  </Text>
                                </MenuOption>
                              </View>
                            </View>
                          </MenuOptions>
                        </Menu>
                      </View>
                    </View>
                  ) : (
                    <View style={{ flexDirection: "row" }}>
                      <Menu>
                        <MenuTrigger>
                          <View
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              width: 32,
                            }}
                          >
                            <SimpleLineIcons
                              name="options"
                              size={18}
                              color="grey"
                            />
                          </View>
                        </MenuTrigger>
                        <MenuOptions
                          optionsContainerStyle={{
                            padding: 2,
                            zIndex: 999,
                            marginLeft: -120,
                            marginTop: -10,
                            width: 200,
                          }}
                        >
                          <View
                            style={{ flexDirection: "row", flexWrap: "wrap" }}
                          >
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{ flex: 1, alignItems: "center" }}
                                onSelect={() => operationActions?.(row, "view")}
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="eye"
                                    size={20}
                                    color="#5F6368"
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{ flex: 1, alignItems: "center" }}
                                disabled={
                                  row?.OrderStatus === "Cancelled"
                                    ? true
                                    : false
                                }
                                onSelect={() => operationActions?.(row, "flag")}
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="flag-outline"
                                    size={20}
                                    color={
                                      row?.OrderStatus === "Cancelled"
                                        ? "#eee"
                                        : "#5F6368"
                                    }
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{ flex: 1, alignItems: "center" }}
                                disabled={
                                  row?.OrderStatus === "Cancelled"
                                    ? true
                                    : false
                                }
                                onSelect={() => operationActions?.(row, "add")}
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="comment-outline"
                                    size={20}
                                    color={
                                      row?.OrderStatus === "Cancelled"
                                        ? "#eee"
                                        : "#5F6368"
                                    }
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{ flex: 1, alignItems: "center" }}
                                onSelect={() =>
                                  operationActions?.(row, "history")
                                }
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="clock-outline"
                                    size={20}
                                    color="#5F6368"
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                            <View style={styles.menuOptionContainer}>
                              <MenuOption
                                style={{ flex: 1, alignItems: "center" }}
                                onSelect={() =>
                                  operationActions?.(row, "shipments")
                                }
                              >
                                <Text>
                                  <MaterialCommunityIcons
                                    name="truck-outline"
                                    size={20}
                                    color="#5F6368"
                                    style={[styles.actionsIcons]}
                                  />
                                </Text>
                              </MenuOption>
                            </View>
                          </View>
                        </MenuOptions>
                      </Menu>
                    </View>
                  )}
                </View>,
              );
          }
        }
      });

      if (row) {
        rowsViews.push(
          <React.Fragment key={index}>
            <DataTable.Row
              style={{
                backgroundColor: operationsScreen
                  ? "#fff"
                  : switchToExpand
                    ? "#eee"
                    : "white",
              }}
              key={`${Services.makeid(10)}_${index}`}
            >
              {views}
            </DataTable.Row>

            {isRowsExpandable && switchToExpand && (
              <ChinaNestedDataTableWithPagination2
                itemsPerPage={itemsPerPage}
                isNestedDataLoaded={isNestedDataLoaded}
                nestedHeader={nestedHeader}
                nestedRows={row[nestedItemKeyValue as string]}
                rowKeyValue={rowKeyValue}
                isDetail={isSubDetail}
                setModalVisible={setModalVisible}
                handleRowClick={handleRowClick}
                setSelected={setSelected}
                currentRow={currentRow}
                prefixRow={row}
                key="rowKeyValue"
                nestedColumnsToNotHaveThousandSeparator={
                  columnsToNotHaveThousandSeparator
                }
                isDisplayTimeWithDate={isDisplayTimeWithDate}
                handleNestedSortColumn={handleNestedSortColumn}
                disableHeader={disableHeader}
                operationActions={operationActions}
              />
            )}
          </React.Fragment>,
        );
      }
    });
    return rowsViews;
  };

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "white",
        }}
      >
        <DataTable.Header>{headersView(headers)}</DataTable.Header>
      </View>

      <ScrollView style={{ flex: 1 }}>
        {isDataLoading ? (
          <View>
            <Spinner
              size="small"
              color="#74BBFF"
              styles={{
                flexDirection: "row",
                marginTop: "5%",
                marginBottom: "5%",
              }}
            />
          </View>
        ) : rows.length > 0 ? (
          cellsView(
            rows.slice(
              page * _itemsPerPage,
              page * _itemsPerPage + _itemsPerPage,
            ),
            headers,
          )
        ) : (
          <NoDataBanner />
        )}
        <DataTable.Pagination
          page={page}
          numberOfPages={Math.ceil(rows.length / _itemsPerPage)}
          onPageChange={(page) => setPage(page)}
          label={`${fromPage(page, itemsPerPage, rows)} of ${rows.length}`}
          showFastPaginationControls
          numberOfItemsPerPage={_itemsPerPage}
          selectPageDropdownLabel={"Rows per page"}
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  collapsableView: {
    flex: 1,
    borderStyle: "solid",
    borderColor: "rgba(47, 149, 220, 0.5)",
    borderWidth: 1,
  },
  actionsIcons: {
    paddingHorizontal: 2,
    cursor: "pointer",
  },
  menuOptionContainer: {
    flex: 1,
    marginHorizontal: 2,
  },
});
